import React from "react";
import startButton from "assets/images/vb/start-button.png";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fade_bounce_delay_variants,
  bounce_right_to_left_variants
} from "shared/components/animations";

const VBPreGuess = ({ role, joke, activeQB, onUpdateStatus }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="vb-pre-guess"
    >
      {role === "quarterback" ? (
        <motion.div
          variants={bounce_right_to_left_variants}
          className="vb-card-div"
        >
          <h2 className="vb-primary-text captain">You're the Captain!</h2>
          <p className="vb-secondary-text quarterback">
            Try to get your team to say the word without:
          </p>
          <ul className="quarterback-list">
            <li className="vb-secondary-text quarterback">
              Saying any of the banned words
            </li>
            <li className="vb-secondary-text quarterback last">
              Using sounds or gestures to indicate the word
            </li>
          </ul>
        </motion.div>
      ) : role === "guesser" ? (
        <motion.div
          variants={bounce_right_to_left_variants}
          className="vb-card-div"
        >
          <h2 className="vb-primary-text card-text">Your team's Captain:</h2>
          <img alt="" src={activeQB.profile_image} className="avatar" />
          <h2 className="name">{activeQB.display_name}</h2>
          <p className="vb-secondary-text">The round is about to start!</p>
          <p className="vb-secondary-text last">
            When the round starts, listen to clues from your Captain to guess
            the word!
          </p>
        </motion.div>
      ) : (
        <motion.div
          variants={bounce_right_to_left_variants}
          className="vb-card-div"
        >
          <h2 className="vb-primary-text card-text">
            The other team's Captain:
          </h2>
          <img alt="" src={activeQB.profile_image} className="avatar" />
          <h2 className="name">{activeQB.display_name}</h2>
          <p className="vb-secondary-text">The round is about to start!</p>
          <p className="vb-secondary-text last">
            When the round starts, hit the buzzer if the other team's Captain
            says a banned word!
          </p>
        </motion.div>
      )}
      {role === "quarterback" ? (
        <>
          <motion.p
            variants={fade_bounce_delay_variants}
            className="joke-text quarterback"
          >
            Start the round when ready!
          </motion.p>
          <motion.img
            alt=""
            variants={fade_bounce_delay_variants}
            src={startButton}
            className="status-button"
            onClick={() => onUpdateStatus("update")}
          />
          <motion.h2
            variants={fade_bounce_delay_variants}
            className="next-round-text"
          >
            START
          </motion.h2>
        </>
      ) : (
        <>
          <motion.h2
            variants={fade_bounce_delay_variants}
            className="joke-label overflow"
          >
            Did you know?
          </motion.h2>
          <motion.p variants={fade_bounce_delay_variants} className="joke-text">
            {joke !== ""
              ? joke
              : `"Patience is not an ability to wait, but the ability to keep a good
            attitude while waiting." -Annoying Person`}
          </motion.p>
        </>
      )}
    </motion.div>
  );
};

export default VBPreGuess;
